export default __webpack_public_path__ + "static/assets/f1c8491d5f7fe4db235174f88784eb02.svg";